module.exports = __webpack_public_path__ + "img/pythonbox1pic1.b094a5c8.png";